export function arredondar(num, decimais = 1) {
  const fator = 10 * decimais;

  return Math.round((parseFloat(num) + Number.EPSILON) * fator) / fator;
}

export function formatarMilhares(valor) {
  if (!valor) {
    return 'N/I';
  }

  if (typeof valor === 'string') {
    valor = parseFloat(valor.replace(',', '.'));
  }

  if (Number.isNaN(valor)) {
    return 'Valor inválido';
  }

  return valor.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/**
 * Função para formatar números de quantidade, foi criada essa função específica porque às vezes temos quantidades nesse formato
 * 953.4960000000001, que deve ficar 953,50 e valores que não tem casa após a vírgula mantém o seu valor original
 * @param {number} valor Valor a ser formatado
 */
export function formatarNumeroDeQuantidade(valor) {
  const arredondado = Math.round(valor * 100) / 100;

  if (arredondado === Math.floor(arredondado)) {
    return arredondado.toString();
  }

  return arredondado.toFixed(2).replace('.', ',');
}
